import { ca } from '@cian/analytics';

type TModalAction = 'Show' | 'Close' | 'Scroll';

export interface ITrackCompareModalEventProps {
  action: TModalAction;
  label: 'description_modal' | 'pages';
  pageId?: number;
}

export interface ITrackShowOnbordingTooltipProps {
  action: 'Show' | 'Click';
  label: 'tooltip' | 'tooltip_about_link';
}

function trackCompareModalEvent({ action, label, pageId }: ITrackCompareModalEventProps): void {
  ca('eventSite', {
    action,
    label,
    name: 'oldevent',
    category: 'CompareJKPromo',
    page: {
      pageType: 'CardJK',
      ...(pageId === undefined ? {} : { extra: { page_number: pageId } }),
    },
  });
}

export function trackShowCompareModal(): void {
  trackCompareModalEvent({ action: 'Show', label: 'description_modal' });
}

export function trackCloseCompareModal(): void {
  trackCompareModalEvent({ action: 'Close', label: 'pages' });
}

export function trackScrollCompareModal(pageId: number): void {
  trackCompareModalEvent({ action: 'Scroll', label: 'pages', pageId });
}

export function trackOnbordingTooltip({ action, label }: ITrackShowOnbordingTooltipProps): void {
  ca('eventSite', {
    action,
    label,
    name: 'oldevent',
    category: 'CompareJKPromo',
    page: {
      pageType: 'CardJK',
    },
  });
}
